import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BOMRepository from "../../../repository/BOMRepository";
import BOM from "../../../model/BOM";
import { load_initialState } from "src/store/slice/model/BOM/BOMDownloadPopup.js";
import BOMAPICall from "../../../service/BOMAPICall";
import store from "../../../storeWire";
import { __remove, __set } from "../../axios_indicator";

export const fetchBOMList = createAsyncThunk('bom_fetchBOMList', async () => {
    __set('BOM_API_CALL');
    return new BOM().toObjectWithBOMID(
        await new BOMRepository().fetchBOMList()
    );
});

export const fetchProductCategoryList = createAsyncThunk('bom_fetchProductCategoryList', async () => {
    __set('BOM_PRODUCT_CATEGORY_API_CALL');
    return await new BOMRepository().fetchProductCategoryList();
});

export const create_bom = createAsyncThunk('bom_create_bom', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    /**
     * Send ERPMFRPartNumber for used as partNumber
     * Author: Devanshi Patel
     */
    return await new BOMRepository().createBOM(params)
});

export const create_blank_bom = createAsyncThunk('bom_create_blank_bom', async () => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().createBlankBOM()
});

export const edit_bom_name = createAsyncThunk('bom_edit_bom_name', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().editBOMName(params.bomName, params.bomId)
});

export const set_is_rematch_flag = createAsyncThunk('bom_set_is_rematch_flag', async (params) => {
    __set('BOM_REMATCH_FLAG_OPERATION_API_CALL');
    return await new BOMRepository().setBOMIsRematchFlag(params.bomId)
});

export const add_part_to_bom = createAsyncThunk('bom_add_part_to_bom', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().addPartToBOM(params)
});

export const getBomDetailByBomID = createAsyncThunk('bom_getBomDetailByBomID', async (params) => {
    __set('BOM_API_CALL');
    return await new BOMRepository().getBomDetailByBomID(params.bomId)
});

export const deleteBOMByBomID = createAsyncThunk('bom_deleteBOMByBomID', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().deleteBOMByBomID(params.bomId)
});

export const copyBOMByBomID = createAsyncThunk('bom_copyBOMByBomID', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().copyBOMByBomID(params)
});

export const getBomHealthByBomID = createAsyncThunk('bom_getBomHealthByBomID', async (params) => {
    __set('BOM_HEALTH_API_CALL');
    return await new BOMRepository().getBomHealthByBomID(params.bomId)
});

export const getBomDetailByBomIDWithType = createAsyncThunk('bom_getBomDetailByBomIDWithType', async (params) => {
    __set('BOM_TAB_API_CALL');
    if (params.top === undefined) {
        params.top = 10;
    }
    if (params.force_all_skip_redux_check === undefined) {
        params.force_all_skip_redux_check = false;
    }

    return await new BOMRepository().getBomDetailByBomIDWithType(params.bomId, params.matchType, params.sortColumn, params.sortOrder, params.isReRunPartMatch, params.top, params.force_all_skip_redux_check, params.callFrom, params.skip)
});

export const getBomDetailCountByBomID = createAsyncThunk('bom_getBomDetailCountByBomID', async (params) => {
    __set('BOM_TAB_API_CALL');
    if (params.top === undefined) {
        params.top = 10;
    }
    if (params.force_all_skip_redux_check === undefined) {
        params.force_all_skip_redux_check = false;
    }
    return await new BOMRepository().getBomDetailCountByBomID(params.bomId)
});

export const bomUploadFile = createAsyncThunk('bom_uploadBomFile', async (params) => {
    __set('BOM_UPLOAD_OPERATION_API_CALL');
    return await new BOMAPICall().bomUploadFile(params.file, params.source);
});

export const bomDownloadFile = createAsyncThunk('bom_downloadBomFile', async (params) => {
    __set('BOM_DOWNLOAD_API_CALL');
    return await new BOMRepository().bomDownloadFile(params.bomId, params.fileType, params.fieldColumns, params.currentCurrency);
});

export const bomEmailFile = createAsyncThunk('bom_bomEmailFile', async (params) => {
    __set('BOM_EMAIL_API_CALL');
    return await new BOMRepository().bomEmailFile(params.bomId, params.fileType, params.fieldColumns, params.recipientEmail, params.senderEmail, params.message, params.currentCurrency);
});

export const fetchDownloadFileSavePreference = createAsyncThunk('bom_fetchDownloadFileSavePreference', async (params) => {
    __set('BOM_SAVE_PREFERENCE_API_CALL');
    let r = await new BOMRepository().fetchDownloadFilePreference(params);
    store.dispatch(load_initialState(r));
    return r;
});

export const download_bom_template = createAsyncThunk('bom_download_bom_template', async () => {
    return await new BOMRepository().downloadBomTemplate()
});

export const create_part_list = createAsyncThunk('bom_create_part_list', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().createPartList(params)
});

export const bom_assign_to_project = createAsyncThunk('bom_assign_to_project', async (params) => {
    __set('BOM_ASSIGN_TO_PROJECT_API_CALL');
    return await new BOMRepository().assignBOMToProject(params.bomId, params.projectId)
});

export const swap_part_number = createAsyncThunk('bom_swap_part_number', async (params) => {
    __set('BOM_SWAP_PART_NUMBER_API_CALL');
    return await new BOMRepository().swapPartNumber(params)
});

export const updateQuantityByBomDetailID = createAsyncThunk('bom_detail_updateQuantityByBomDetailID', async (params) => {
    return await new BOMRepository().updateQuantityByBomDetailID(params.bomDetailId, params.quantity)
});

export const updateCustomerPartNumberByBomDetailID = createAsyncThunk('bom_detail_updateCustomerPartNumberByBomDetailID', async (params) => {
    return await new BOMRepository().updateCustomerPartNumberByBomDetailID(params)
});

export const remove_part_number = createAsyncThunk('bom_remove_part_number', async (params) => {
    __set('BOM_OPERATION_API_CALL');
    return await new BOMRepository().removePartNumber(params.bomDetailId, params.bomId)
});

export const getFarnellBomList = createAsyncThunk('bom_fetch_Farnell_bom_list', async (params) => {
    __set('BOM_FARNELL_LIST_API_CALL');
    return await new BOMRepository().getFarnellBomList(params)
});

const initialState = {
    bomList: {},
    bomDetailByBomID: {},
    bomDetailByBomIDWithType: {},
    bomUploadFile__progress_percentage: 0,
    bomHealthByBomID: {},
    bomMultipleMatchTrigger: '',
    bomSortByUpdatedDate: false,
    farnellBomList:{}
};
const slice = createSlice({
    name: "BOM",
    initialState: initialState,
    reducers: {
        SET_bomUploadFile__progress_percentage: {
            reducer: (state, action) => {
                state.bomUploadFile__progress_percentage = action.payload.percentage
            },
        },
        SET_quantity_exact_match_tab_by_bomDetailId: {
            reducer: (state, action) => {
                state.bomDetailByBomIDWithType['Exact'].records[action.payload.bomDetailId].quantity = action.payload.quantity;
            },
        },
        FORCE_remove_bomDetailByBomIDWithType_by_type: {
            reducer: (state, action) => {
                state.bomDetailByBomIDWithType[action.payload.matchType].records = {};
                return state;
            },
        },
        SET_bomMultipleMatchTrigger: {
            reducer: (state, action) => {
                state.bomMultipleMatchTrigger = action.payload.BOMTriggerVal
            },
        },
        SET_bomSortByUpdatedDate: {
            reducer: (state, action) => {
                state.bomSortByUpdatedDate = true
            },
        },
        UPDATE_BomfarnellData: {
            reducer: (state, action) => {
                state.farnellBomList.manufacturerPartNumberSearchReturn.products = state.farnellBomList.manufacturerPartNumberSearchReturn.products.map((product) => {
                    if (product.sku === action.payload.params?.sku) {
                        return {
                            ...product,
                            translatedMinimumOrderQuality: action.payload.params.value,
                            qtyError: action.payload.params.value < 1 || action.payload.params.value > product.stock.level ? true: false
                        };
                    }
                    return product;
                });
            },
        },
    },
    extraReducers: {
        [fetchBOMList.fulfilled]: (state, { payload }) => {
            state.bomList = payload.bomList;
            __remove('BOM_API_CALL');
            return state;
        },
        [fetchBOMList.rejected]: (state, { payload }) => {
            __remove('BOM_API_CALL');
        },
        [getBomDetailByBomID.fulfilled]: (state, { payload }) => {
            state.bomDetailByBomID = payload;
            __remove('BOM_API_CALL');
            return state;
        },
        [getBomDetailByBomID.rejected]: (state, { payload }) => {
            __remove('BOM_API_CALL');
        },
        [getBomDetailByBomIDWithType.fulfilled]: (state, { payload }) => {
            let res = { ...payload.data }
            if (payload.data?.Exact?.records) {
                // Convert the object of objects into an array of key-value pairs
                let arrayOfKeyValuePairs = Object.entries(payload.data?.Exact?.records);

                // Sort the array based on the 'index' key in inner objects
                arrayOfKeyValuePairs.sort(([, objA], [, objB]) => objA.index - objB.index);

                // Reconstruct the object from the sorted array
                let sortedObjectOfObjects = arrayOfKeyValuePairs.reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

                res.Exact.records = sortedObjectOfObjects
            }

            state.bomDetailByBomIDWithType = res;
            __remove('BOM_TAB_API_CALL');
            return state;
        },
        [getBomDetailByBomIDWithType.rejected]: (state, { payload }) => {
            __remove('BOM_TAB_API_CALL');
        },
        [getBomHealthByBomID.fulfilled]: (state, { payload }) => {
            state.bomHealthByBomID = payload;
            __remove('BOM_HEALTH_API_CALL');
            return state;
        },
        [getBomHealthByBomID.rejected]: (state, { payload }) => {
            __remove('BOM_HEALTH_API_CALL');
        },
        [create_part_list.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [create_part_list.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [swap_part_number.fulfilled]: (state, { payload }) => {
            __remove('BOM_SWAP_PART_NUMBER_API_CALL');
        },
        [swap_part_number.rejected]: (state, { payload }) => {
            __remove('BOM_SWAP_PART_NUMBER_API_CALL');
        },
        [updateQuantityByBomDetailID.fulfilled]: (state, { payload }) => {
        },
        [updateQuantityByBomDetailID.rejected]: (state, { payload }) => {
        },
        [remove_part_number.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [remove_part_number.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [bomDownloadFile.fulfilled]: (state, { payload }) => {
            __remove('BOM_DOWNLOAD_API_CALL');
        },
        [bomDownloadFile.rejected]: (state, { payload }) => {
            __remove('BOM_DOWNLOAD_API_CALL');
        },
        [bomEmailFile.fulfilled]: (state, { payload }) => {
            __remove('BOM_EMAIL_API_CALL');
        },
        [bomEmailFile.rejected]: (state, { payload }) => {
            __remove('BOM_EMAIL_API_CALL');
        },
        [deleteBOMByBomID.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [deleteBOMByBomID.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [fetchDownloadFileSavePreference.fulfilled]: (state, { payload }) => {
            __remove('BOM_SAVE_PREFERENCE_API_CALL');
        },
        [fetchDownloadFileSavePreference.rejected]: (state, { payload }) => {
            __remove('BOM_SAVE_PREFERENCE_API_CALL');
        },
        [fetchProductCategoryList.fulfilled]: (state, { payload }) => {
            __remove('BOM_PRODUCT_CATEGORY_API_CALL');
        },
        [fetchProductCategoryList.rejected]: (state, { payload }) => {
            __remove('BOM_PRODUCT_CATEGORY_API_CALL');
        },
        [create_bom.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [create_bom.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [edit_bom_name.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [edit_bom_name.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [set_is_rematch_flag.rejected]: (state, { payload }) => {
            __remove('BOM_REMATCH_FLAG_OPERATION_API_CALL');
        },
        [set_is_rematch_flag.fulfilled]: (state, { payload }) => {
            __remove('BOM_REMATCH_FLAG_OPERATION_API_CALL');
        },
        [create_blank_bom.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [create_blank_bom.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [add_part_to_bom.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [add_part_to_bom.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [copyBOMByBomID.rejected]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [copyBOMByBomID.fulfilled]: (state, { payload }) => {
            __remove('BOM_OPERATION_API_CALL');
        },
        [bomUploadFile.rejected]: (state, { payload }) => {
            __remove('BOM_UPLOAD_OPERATION_API_CALL');
        },
        [bomUploadFile.fulfilled]: (state, { payload }) => {
            __remove('BOM_UPLOAD_OPERATION_API_CALL');
        },
        [bom_assign_to_project.rejected]: (state, { payload }) => {
            __remove('BOM_ASSIGN_TO_PROJECT_API_CALL');
        },
        [bom_assign_to_project.fulfilled]: (state, { payload }) => {
            __remove('BOM_ASSIGN_TO_PROJECT_API_CALL');
        },
        [getFarnellBomList.fulfilled]: (state, { payload }) => {
            state.farnellBomList = payload.data;
            __remove('BOM_FARNELL_LIST_API_CALL');
            return state;
        },
        [getFarnellBomList.rejected]: (state, { payload }) => {
            __remove('BOM_FARNELL_LIST_API_CALL');
        },
    },
});

export let { SET_bomUploadFile__progress_percentage, SET_quantity_exact_match_tab_by_bomDetailId, FORCE_remove_bomDetailByBomIDWithType_by_type, SET_bomMultipleMatchTrigger, SET_bomSortByUpdatedDate,UPDATE_BomfarnellData } = slice.actions;

export default slice.reducer;
